import { Star, StarBorder } from '@mui/icons-material'
import { IconButton, ListItem, ListItemText, Stack } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type OptionRowProps = {
  optionLabel: string
  isStarred: boolean
  onToggleStar: () => void
}

const OptionRow: React.FC<OptionRowProps> = ({ optionLabel, isStarred, onToggleStar }) => {
  const { formatMessage } = useIntl()
  return (
    <ListItem disablePadding sx={{ pl: 4, pr: 1, bgcolor: 'background.paper' }}>
      <Stack direction="row" alignItems="center" spacing={1} width="100%">
        <IconButton
          onClick={onToggleStar}
          aria-label={formatMessage({
            id: isStarred
              ? 'form.createAutomation.highlightImportantKpis.unstarOption'
              : 'form.createAutomation.highlightImportantKpis.starOption',
          })}
          sx={{ color: isStarred ? 'primary.main' : 'action.active' }}
        >
          {isStarred ? <Star /> : <StarBorder />}
        </IconButton>
        <ListItemText primary={optionLabel} primaryTypographyProps={{ variant: 'body2' }} />
      </Stack>
    </ListItem>
  )
}

export default OptionRow
